module.exports = __webpack_public_path__ + "img/AI_12.b78268a9.png";